import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { i18n } from '../../language';
import { authNameE, roleMapFunc } from '../../utils/userFuncs';
import { SETTING_EDIT_TABLE, SETTING_TAB_ACTION_ID } from '../../comm/constant';
import { SET_UNEDIT } from '../../redux/constant';
import Dialog from '../../components/Dialog';
import { Mapping, Role, TabBar, User, Ward, Equipment, Tele, ChatCategory } from './components';
import Hospital from './components/Hospital';
import HospitalTag from './components/HospitalTag';
import WardTag from './components/WardTag';
import Admission from './components/Admission';
import BedStatus from './components/BedStatus';
const useStyles = makeStyles((theme) => ({
  toolBar: {
    position: 'fixed',
    top: '4.375rem',
    left: '6.25rem',
    right: '0',
    bottom: '0',
  },
}));

const televisit = (setLeaveOpen, setContinueFunc) => () =>
  <Tele setLeaveOpen={setLeaveOpen} setContinueFunc={setContinueFunc} />;

function Setting() {
  const classes = useStyles();
  const sysTypeLocal = sessionStorage.getItem(SETTING_TAB_ACTION_ID);
  const loginInfo = useSelector((state) => state.loginInfo);
  const roleMap = useSelector((state) => state.roleMap);
  const rouList = useSelector((state) => state.rouList);
  const wardInfo = useSelector((state) => state.wardInfo);
  const [leaveOpen, setLeaveOpen] = useState(false);
  const dispatch = useDispatch();
  const editFlag = useSelector((state) => state.dutyEditFlag);
  const [continueFunc, setContinueFunc] = useState(() => {});

  const [initTabView, setInitTabView] = useState([]);

  useEffect(() => {
    if (roleMap[authNameE.setting]) {
      if (loginInfo.flag) {
        const result = [
          { id: authNameE.setting_view_Hospital, Component: Hospital },
          { id: authNameE.setting_view_ward, Component: Ward },
          { id: authNameE.setting_view_role, Component: Role },
          { id: authNameE.setting_view_Ward_ChatCategory, Component: ChatCategory },
          { id: authNameE.setting_view_user, Component: User },
          { id: authNameE.setting_view_equipment, Component: Equipment },
          { id: authNameE.setting_view_databaseMapping, Component: Mapping },
          { id: authNameE.setting_view_TeleVisit, Component: televisit(setLeaveOpen, setContinueFunc) },
          { id: authNameE.setting_view_Hospital_Tag, Component: HospitalTag },
          { id: authNameE.setting_view_Ward_Tag, Component: WardTag },
          { id: authNameE.setting_view_admission, Component: Admission },
          { id: authNameE.setting_view_bedstatus, Component: BedStatus },
        ];
        const ids = roleMapFunc.getSettingTabIds(roleMap);
        if (sessionStorage.getItem(SETTING_EDIT_TABLE)) {
          sessionStorage.removeItem(SETTING_EDIT_TABLE);
        } else {
          setInitTabView(
            result.filter((item) => {
              return ids?.includes(item.id) ;
            })
          );
        }
      } else if (wardInfo.flag) {
        setInitTabView([]);
      }
    }
  }, [rouList]);

  const [idx, setIdx] = useState(sysTypeLocal ? Number(sysTypeLocal) : initTabView?.[0]?.id ?? -1);

  const Comn = useCallback(
    ({ edit }) => {
      return loginInfo.flag ? (
        <TabBar
          lists={initTabView}
          className={classes.toolBar}
          onClick={(ids) => {
            if (edit) {
              setLeaveOpen(true);
              setContinueFunc(() => () => {
                sessionStorage.setItem(SETTING_TAB_ACTION_ID, ids);
                setIdx(ids);
              });
            } else {
              sessionStorage.setItem(SETTING_TAB_ACTION_ID, ids);
              setIdx(ids);
            }
          }}
          index={(() => {
            const temp = _.find(initTabView, (item) => item.id === idx);
            return temp ? temp.id : initTabView?.[0]?.id ?? -1;
          })()}
        />
      ) : (
        <TabBar lists={[]} className={classes.toolBar} onClick={(ids) => {}} index={(() => 0)()} />
      );
    },
    [initTabView, idx]
  );

  const handleConfirmLeave = useCallback(() => {
    setLeaveOpen(false);
    dispatch({ type: SET_UNEDIT });
    continueFunc();
  }, [continueFunc]);

  const handleCancelLeave = useCallback(() => {
    setLeaveOpen(false);
  }, []);

  return (
    <>
      <Dialog
        open={leaveOpen}
        title={i18n.t('DUTYASSIGN_NOT_SAVE_TITLE')}
        cancel={i18n.t('DUTYASSIGN_CANCEL')}
        confirm={i18n.t('DUTYASSIGN_CONFIRM')}
        handleClose={handleCancelLeave}
        handleCancel={handleCancelLeave}
        handleConfirm={handleConfirmLeave}
      >
        <div
          style={{
            color: '#2e4469',
            fontSize: '1.25rem',
            fontFamily: 'NotoSans-Medium',
            fontWeight: 500,
            lineHeight: '1.875rem',
          }}
        >
          {i18n.t('DUTYASSIGN_NOT_SAVE_BODY')}
        </div>
      </Dialog>
      <Comn edit={editFlag} />
    </>
  );
}

export default Setting;
